// Helper function to get the display text from a rendered value
export const getDisplayText = renderedValue => {
  if (renderedValue && typeof renderedValue === "object" && renderedValue.props) {
    if (renderedValue.props.children) {
      const children = renderedValue.props.children;
      if (typeof children === "string") return children;
      if (Array.isArray(children)) {
        return children.map(child => (typeof child === "string" ? child : "")).join("");
      }
    }
  }

  return String(renderedValue ?? "");
};

// Checks if a row matches the filter criteria for a specific column
export const matchesColumnFilter = (col, row, filters) => {
  if (col.filterable === false || !filters[col.key]) return true;

  const filterText = filters[col.key]?.trim();
  if (!filterText) return true;

  const rawValue = row?.[col.key];

  let displayValue;
  if (col.render) {
    const rendered = col.render(rawValue, row);
    displayValue = getDisplayText(rendered);
  } else {
    displayValue = String(rawValue ?? "");
  }

  return displayValue.toLowerCase().includes(filterText.toLowerCase());
};
